import { Card, CardBody, Divider } from '@chakra-ui/react';

import { withConfirm, Section, ItemAmount, Total, SubHeading } from 'shared-components';

import { formatCurrency } from '../../../utilities/formatting';
import { FundingSummary } from '../../../types';
import { dependantChildrenLabel } from '../../../utilities/sponsors';
import { useTranslation } from "react-i18next";

interface IProps {
  fundingSummary: FundingSummary;
}

function formatAmount(amount: number) {
  return `£${formatCurrency(amount)}`;
}

function FundingTable(props: IProps) {
    const { t } = useTranslation('common');
  const { courseFees, studentLivingCost, spouseLivingCost, childrenLivingCost, totalToBeShown } = props.fundingSummary;

  function renderCourseFee() {
    if (courseFees.length === 0) return null;

    return (
      <Section data-selector="funding-course-fee" title={t('common:courseFee')}>
        {courseFees.map((fund, i) => (
          <ItemAmount key={i} label={fund.label} amount={formatAmount(fund.amount)} />
        ))}
      </Section>
    );
  }

  function renderStudentLivingCost() {
    if (studentLivingCost.amount === 0) return null;

    return (
      <Section data-selector="funding-student-living-cost" title={t('common:yourLivingCost')}>
        <ItemAmount label={studentLivingCost.label} amount={formatAmount(studentLivingCost.amount)} />
      </Section>
    );
  }

  function renderDependantLivingCost() {
    if (spouseLivingCost.amount === 0 && childrenLivingCost.amount === 0) return null;

    return (
      <Section data-selector="funding-dependant-living-cost" title={t('common:dependantSLivingCost')}>
        {spouseLivingCost.amount !== 0 && <ItemAmount label={t('common:partner')} amount={formatAmount(spouseLivingCost.amount)} />}

        {childrenLivingCost.amount !== 0 && (
          <ItemAmount
            label={dependantChildrenLabel(childrenLivingCost.number)}
            amount={formatAmount(childrenLivingCost.amount)}
          />
        )}
      </Section>
    );
  }

  function renderTotal() {
    return <Total label={t('common:totalFundingToBeShown')} amount={formatAmount(totalToBeShown)} />;
  }

  return (
    <>
      <SubHeading>{t('common:whatYouNeedToProveYouHaveAvailab')}</SubHeading>

      <Card data-selector="funding-table" variant="filled" borderRadius="lg">
        <CardBody>
          {renderCourseFee()}
          {renderStudentLivingCost()}
          {renderDependantLivingCost()}
          <Divider mt={6} mb={6} />
          {renderTotal()}
        </CardBody>
      </Card>
    </>
  );
}

export default withConfirm(FundingTable);
